import FVendor from "@/models/f-vendor";


export const vendorModule = {
    namespace: true,
    state: {
        itemModifiedVendor: new FVendor(),
        formModeVendor: String,
    },
    actions:{
        updateItemModifiedVendor({commit}, payload) {
            commit('mutateItemModifiedVendor', payload)
        },
        updateFormModeVendor({commit}, payload){
            commit('mutateFormModeVendor', payload)
        },
    },
    mutations:{
        mutateItemModifiedVendor(state, payLoad) {
          state.itemModifiedVendor = payLoad
        },
        mutateFormModeVendor(state, payLoad){
            state.formModeVendor = payLoad
        },
    }

}